'use client';

import { cn } from '@/lib/utils';

/** Inline Flaunch mark — a soft rocket silhouette. */
export function FlaunchIcon({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn('shrink-0', className)}
      aria-hidden
      fill="none"
    >
      <defs>
        <linearGradient id="flaunch-body" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ff8dcb" />
          <stop offset="100%" stopColor="#c054e5" />
        </linearGradient>
      </defs>
      <path
        d="M12 2 C15.5 5 17 8 17 12 C17 14.2 16 15.8 14.5 17 L12 19 L9.5 17 C8 15.8 7 14.2 7 12 C7 8 8.5 5 12 2 Z"
        fill="url(#flaunch-body)"
        stroke="#7a1f95"
        strokeWidth="0.8"
      />
      <circle cx="12" cy="10" r="2" fill="#fff8" stroke="#7a1f95" strokeWidth="0.6" />
      <path
        d="M9 17 L7.5 22 L11 19 M15 17 L16.5 22 L13 19"
        fill="#ff5eae"
        stroke="#7a1f95"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Inline Uniswap unicorn-horn silhouette. */
export function UniswapIcon({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn('shrink-0', className)}
      aria-hidden
      fill="none"
    >
      <defs>
        <linearGradient id="uni-body" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ff79c3" />
          <stop offset="100%" stopColor="#d94294" />
        </linearGradient>
      </defs>
      <path
        d="M7 19 C5 15 7 11 11 9 C13 8 15 7 16 4 C17.5 7 17 11 15 13 C17 12 18 13 19 15 C16 15 13 16 11 18 C10 16 9 15 7 15 C7 17 7 18 7 19 Z"
        fill="url(#uni-body)"
        stroke="#a6236d"
        strokeWidth="0.6"
        strokeLinejoin="round"
      />
      <circle cx="14.5" cy="9.5" r="0.7" fill="#2a0a1c" />
    </svg>
  );
}

/** Inline Dexscreener — simplified candle icon. */
export function DexscreenerIcon({ size = 14, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn('shrink-0', className)}
      aria-hidden
    >
      <rect x="5" y="4" width="2" height="16" rx="0.5" fill="#39d79e" />
      <rect x="4" y="8" width="4" height="6" rx="0.5" fill="#39d79e" />
      <rect x="11" y="2" width="2" height="20" rx="0.5" fill="#39d79e" />
      <rect x="10" y="5" width="4" height="9" rx="0.5" fill="#39d79e" />
      <rect x="17" y="6" width="2" height="14" rx="0.5" fill="#e8518a" />
      <rect x="16" y="10" width="4" height="8" rx="0.5" fill="#e8518a" />
    </svg>
  );
}

/** Generic X / Telegram / Globe marks (inline so we don't add a dep). */
export function XIcon({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={cn('shrink-0', className)}>
      <path
        fill="currentColor"
        d="M18.244 2H21.5l-7.56 8.64L23 22h-6.97l-5.47-6.66L4.4 22H1.14l8.1-9.27L1 2h7.14l4.95 6.06L18.244 2Zm-1.22 18h1.94L7.08 4H5.04L17.024 20Z"
      />
    </svg>
  );
}

export function TelegramIcon({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={cn('shrink-0', className)}>
      <path
        fill="currentColor"
        d="M21.94 4.68 19.03 20.2c-.22 1-.8 1.24-1.62.78l-4.48-3.3-2.16 2.08c-.24.24-.44.44-.9.44l.32-4.56 8.3-7.5c.36-.32-.08-.5-.56-.18L7.64 13.6l-4.4-1.38c-.96-.3-.98-.96.2-1.42L20.74 3.3c.8-.3 1.5.18 1.2 1.38Z"
      />
    </svg>
  );
}

export function GlobeIcon({ size = 12, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={cn('shrink-0', className)} fill="none">
      <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.4" />
      <path d="M3 12h18M12 3a13 13 0 0 1 0 18M12 3a13 13 0 0 0 0 18" stroke="currentColor" strokeWidth="1.2" />
    </svg>
  );
}
